import { Component, effect, inject, input } from '@angular/core';

import { ToastMessageOptions } from 'primeng/api';
import { NotificationService } from '@lib/notification/data-access';
import { SystemNotificationModel } from '@lib/notification/models';
import { ProblemModel } from '@lib/shared/models';

@Component({
  selector: 'lib-notification-feature-system-notification',
  imports: [],
  templateUrl: './system-notification.component.html',
  styleUrl: './system-notification.component.scss',
})
export class SystemNotificationComponent {
  
  public message = input.required<ToastMessageOptions>();
  private notificationService = inject(NotificationService);

  private systemNotificationEffect = effect(() => {
    if (this.message() && this.message().data && this.message().data.problem) {
      const problem = this.message().data.problem as ProblemModel;
      const systemNotification: SystemNotificationModel = {        
        id: crypto.randomUUID(),
        detail: problem.detail,
        errorCode: problem.errorCode,
        operationId: problem.operationId,
        sessionId: problem.sessionId || '',
        isOperationIdCopied: false,
        tenantId: problem.tenantId,
        problemType: problem.problemType,
        status: problem.status,
        createdOn: new Date(problem.timestamp),
        isRead: false,
        //Convert to local timezone it always comes in as UTC
        timestamp: new Date(problem.timestamp).toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }), 
      };

      this.notificationService.addSystemNotification(systemNotification);
    }
  });
}
